module.exports = {

	deviation_mark_complete: function(self, item) {


		console.log(item);

		item.is_processed = 1;

		
		self.$http.post('/deviations/process', { deviation_id: item.id }).then((response) => {

            

        }, (response) => {
            console.log(JSON.stringify(response));
        });
        


	},

	deviation_save_text: function(self, item, text) {

		self.$http.post('/deviations/saveComment', { deviation_id: item.id, comment: text }).then((response) => {
            
        }, (response) => {
            console.log(JSON.stringify(response));
        });

	},

}